<!--
    Design: https://flowbite.com/docs/components/chat-bubble/
-->
<div class="parent-chat flex relative">
  <div chat-list class="basis-full md:block md:basis-2/6 md:w-2/6 p-6 md:p-0" [ngClass]="{
      'hidden': !!selectedChat.value?.[0] 
    }">
    <div mat-subheader>Chats</div>
    <ng-container *ngIf="appStateChats.size > 0; else noChatList">
      <mat-selection-list #chatsListing [multiple]="false" [formControl]="selectedChat">
        <mat-divider></mat-divider>
        <ng-container *ngFor="let _chat of appStateChats | keyvalue">
          <mat-list-option [value]="_chat?.key">
            <!-- @todo: use corp member's uploaded profile photo -->
            <img matListItemAvatar
              [src]="'https://placehold.co/50x50/4ade80/000/?text=' + (_chat?.value?.chat_display_name ?? 'C.')"
              alt="Profile pic" />
            <div matListItemTitle>
              {{ _chat?.value?.chat_display_name }}
            </div>
            <div matListItemLine>
              {{ _chat?.value?.texts?.at(-1)?.message ?? 'Start new chat...' }}
            </div>
            <div *ngIf="_chat.value.unread_messages" matListItemLine>
              {{ _chat.value.unread_messages }} unread message<span *ngIf="_chat.value.unread_messages > 1">s</span>
            </div>
          </mat-list-option>
          <mat-divider></mat-divider>
        </ng-container>
      </mat-selection-list>
    </ng-container>

    <ng-template #noChatList>
      <mat-divider></mat-divider>
      <p class="pt-3">No chats.</p>
    </ng-template>
  </div>

  <ng-container *ngIf="!!selectedChat.value?.[0]; else noSelectedChat">
      <mat-card class="h-full basis-full md:block md:basis-4/6 md:w-4/6">
        <mat-card-header class="flex justify-between border-b-black border">
          <mat-card-title *ngIf="selectedChatRecipientName">{{ selectedChatRecipientName }}</mat-card-title>
          <mat-card-subtitle>{{
            selectedChatRecipientStateCode
          }}</mat-card-subtitle>

          <button type="button" (click)="closeCurrentChat()" mat-icon-button color="primary" aria-label="Close chat" matTooltip="Close chat">
            <mat-icon>close</mat-icon>
          </button>
        </mat-card-header>

        <mat-card-content class="chats-content" #scroller>
          <!-- *ngIf="(messages$ | async) as messages; else loading" -->
          <ng-container>
            <div class="chats-list scroll-smooth">
              <!-- *ngFor="let message of appStateChats.get(selectedChat.value?.[0])?.texts" -->
              <mat-card class="message-card" *ngFor="let message of selectedChatMessages" [ngClass]="{
                  'sender-chat-message': message?.message_from === callerService.corpMember.id,
                  'recipient-chat-message': message?.message_from !== callerService.corpMember.id
                }">
                <mat-card-content>
                  {{ message.message }}
                </mat-card-content>

                <mat-card-footer class="message-date">
                  <time dateTime="{{message.created_at}}">
                    {{ message.created_at | date : 'd/M/yy, h:mm a' }}
                  </time>
                </mat-card-footer>
              </mat-card>
            </div>
          </ng-container>
        </mat-card-content>

        <mat-card-footer class="flex chat-footer">
          <mat-form-field class="msg-input">
            <mat-label>Enter a message</mat-label>
            <textarea title="Message" [formControl]="chatMessage" matInput cdkTextareaAutosize
              #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5"></textarea>
          </mat-form-field>
          <!-- TODO: send button should also be disabled if there is no internet connection -->
          <button type="button" class="send-message-button" [disabled]="!chatMessage.value" mat-icon-button
            color="primary" aria-label="Send message icon" (click)="sendMessage()">
            <mat-icon>send</mat-icon>
          </button>
        </mat-card-footer>
        <mat-card-footer *ngIf="isSendingMessage">
          <!-- show progress of sending message -->
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </mat-card-footer>

        <!-- <mat-card-actions></mat-card-actions> -->
      </mat-card>
    </ng-container>
    <ng-template #noSelectedChat>
      <div class="hidden basis-full md:flex md:basis-4/6 md:w-4/6 gap-4 flex-col justify-center items-center h-full text-center bg-slate-50">
        <h3>{{ appStateChats.size > 0 ? "Select a chat to start" : "Your chats will appear here"}}</h3>
        <mat-icon color="primary" class="scale-150">forum</mat-icon>
      </div>
    </ng-template>
  
</div>